import { tauriMode } from '@/shared/utils/import-meta'
import { getLocalAudioToURL } from '@/shared/utils/tauri'
import { getAuthenticatedMediaUrl } from '@/shared/utils/url'

export const DEFAULT_RINGTONE_URI = './ringtones/tmobile.mp3'

export const handleRingtoneUri = async (uri: string) => {
  const ringtoneUri = uri ?? DEFAULT_RINGTONE_URI
  if (ringtoneUri === DEFAULT_RINGTONE_URI && tauriMode()) {
    return await getLocalAudioToURL('_up_/dist/ringtones/tmobile.mp3')
  }

  return getAuthenticatedMediaUrl(ringtoneUri)
}
